import { createNodeDef } from "../../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";
import { randChanceBoolean } from "@ngneat/falso";

const chanceType: Record<"true" | "false", string> = {
  true: "Chance True",
  false: "Chance False",
};

export const randChanceBooleanNodeDef = createNodeDef({
  type: "randChanceBoolean",
  displayName: "Chance Boolean",
  defaultName: "boolean",
  fields: [
    {
      type: DataFieldType.SELECT,
      key: "chanceType",
      label: "Type",
      options: chanceType,
    },
    {
      type: DataFieldType.NUMBER,
      key: "chance",
      label: "Chance",
      float: true,
    },
  ],
  initialData: (): {
    chance: number;
    chanceType: keyof typeof chanceType;
  } => ({ chance: 0.1, chanceType: "true" }),
  generate: ({ node }) => {
    const input = node.data.chance;
    const chance = typeof input === "number" ? input : 0.5;
    const chanceType = node.data.chanceType;
    const chanceTrue = chanceType === "true" ? chance : undefined;
    const chanceFalse = chanceType === "false" ? chance : undefined;

    return randChanceBoolean({
      chanceTrue,
      chanceFalse,
    });
  },
});
